import React from 'react';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';

interface props {
  isExpiredYet: boolean;
  flexName: string;
  isRedeemed: boolean;
}

const FlexOptionHeader: React.FC<props> = ({ isExpiredYet, flexName, isRedeemed }) => {
  const intl = useIntl();

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          <TFFTypography
            color={`${isExpiredYet ? 'color-functional-neutral-900' : 'color-functional-neutral-900'}`}
            fontWeight="bold"
            text={`${flexName}`}
            extraStyle={{ fontSize: '24px' }}
          />
          <TFFTypography
            color={isExpiredYet && !isRedeemed ? 'color-functional-neutral-900' : 'color-functional-neutral-000'}
            text={`${isRedeemed ? 'Redeemed' : isExpiredYet ? 'Active' : 'Expired'}`}
            extraStyle={{
              backgroundColor: isExpiredYet && !isRedeemed ? '#30B575' : '#F59300',
              gap: '10px',
              borderRadius: '4px',
              padding: '2px 4px 2px 4px',
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <TFFTypography color="color-functional-neutral-900" fontWeight="bold" text={'Expiration date:'} />
        </div>
      </div>
    </>
  );
};

export default FlexOptionHeader;
